import { render, staticRenderFns } from "./UsersIndex.vue?vue&type=template&id=35dda1ce&scoped=true"
import script from "./UsersIndex.vue?vue&type=script&lang=js"
export * from "./UsersIndex.vue?vue&type=script&lang=js"
import style0 from "./UsersIndex.vue?vue&type=style&index=0&id=35dda1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dda1ce",
  null
  
)

export default component.exports